import ServiceLocator from "../../global/service-locator";
import Navigator from "../../global/navigator";
import Extensions from "../../extensions";
import SiteHeader from "./site-header";
import SiteFooter from "./site-footer";
import Consent from "../../components/consent";

export default class CoreModule {
	constructor() {
		this.sl = ServiceLocator.instance;
		this.navigator = new Navigator();
		this.extensions = new Extensions();
		this.header = new SiteHeader();
		this.footer = new SiteFooter();

		this.initConsent();
	}

	initConsent() {
		new Consent();
	}
}